import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Lock, Unlock } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LockedAccountsCard = () => {
  const [items, setItems] = useState([]);
  const load = () => axios.get(`${API}/admin/locked-accounts`).then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const unlock = async (u) => {
    try {
      const { data } = await axios.post(`${API}/admin/users/${u.id}/unlock-login`);
      toast.success(data.message);
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Déblocage impossible');
    }
  };

  if (items.length === 0) return null;
  return (
    <Card className="border-amber-300" data-testid="locked-accounts-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-amber-800"><Lock className="w-5 h-5" /> Comptes temporairement bloqués</CardTitle>
        <CardDescription>Bloqués après plusieurs mots de passe erronés. Ils se débloquent seuls à l’heure indiquée, ou maintenant avec le bouton.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-2">
        {items.map((u) => (
          <div key={u.id} className="flex items-center justify-between border rounded-md px-3 py-2 text-sm" data-testid={`locked-account-${u.id}`}>
            <span><strong>{u.first_name} {u.last_name}</strong> · {u.email} · jusqu’à {new Date(u.locked_until).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}</span>
            <Button size="sm" variant="outline" onClick={() => unlock(u)} data-testid={`unlock-account-${u.id}`}><Unlock className="w-4 h-4 mr-2" /> Débloquer</Button>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};

export default LockedAccountsCard;
